import React, { useEffect, useState, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Forwarder from '@SiteContainers/Forwarder'
import SpeakerVoicesTable from '@SiteContainers/SpeakerVoicesTable'
import Sidebar from '@SiteContainers/Sidebar'
import RemoveSpeakerVoicePopup from '@SiteContainers/RemoveSpeakerVoicePopup'
import SpeakerVoiceSidePanel from '@SiteContainers/SpeakerVoiceSidePanel'

import {
  fetchSpeakerVoices,
  fetchLanguages,
  setOpenedSpeakerVoiceId,
  resetOpenedSpeakerVoiceId,
  resetIsNewSpeakerVoice,
} from '@SiteModules/SpeakerVoice/actions'

import {
  closeVoiceStudioPopups,
} from '@SiteModules/Popup/actions'

import {
  getCurrentWorkspaceId,
} from '@SiteModules/Workspace/selectors'

import {
  getHasLoadedInitially,
  getOpenedSpeakerVoice,
  getIsNewSpeakerVoice,
} from '@SiteModules/SpeakerVoice/selectors'

import {
  getRemoveSpeakerVoicePopupIsOpen,
} from '@SiteModules/Popup/selectors'

import {
  ISpeakerVoice,
} from '@SiteModules/SpeakerVoice/types'

import './VoiceStudio.scss'

const VoiceStudio: React.FC = () => {
  const dispatch = useDispatch()

  const currentWorkspaceId = useSelector(getCurrentWorkspaceId)
  const hasLoadedInitially = useSelector(getHasLoadedInitially)
  const removeSpeakerVoicePopupIsOpen = useSelector(getRemoveSpeakerVoicePopupIsOpen)
  const openedSpeakerVoice = useSelector(getOpenedSpeakerVoice)
  const isNewSpeakerVoice = useSelector(getIsNewSpeakerVoice)

  const isNewSpeakerVoiceRef = useRef(isNewSpeakerVoice)
  isNewSpeakerVoiceRef.current = isNewSpeakerVoice

  const [fullSpeakerVoiceSidePanel, setFullSpeakerVoiceSidePanel] = useState(false)

  useEffect(() => {
    if (currentWorkspaceId >= 0 && !hasLoadedInitially) {
      dispatch(fetchSpeakerVoices({ workspaceId: currentWorkspaceId, page: 1, includeUsedLanguages: true }))
      dispatch(fetchLanguages())
    }
  } , [currentWorkspaceId, hasLoadedInitially])

  const setCurrentSpeakerVoice = (speakerVoice: ISpeakerVoice) => {
    dispatch(setOpenedSpeakerVoiceId({ speakerVoiceId: speakerVoice.id }))
    if (isNewSpeakerVoiceRef.current) {
      dispatch(resetIsNewSpeakerVoice())
    }
  }

  const handleCloseVoiceStudioPopups = () => {
    dispatch(closeVoiceStudioPopups())
  }

  const resetCurrentSpeakerVoice = () => {
    dispatch(resetOpenedSpeakerVoiceId())
    setFullSpeakerVoiceSidePanel(false)
  }

  const resetIsNewCurrentSpeakerVoice = () => {
    dispatch(resetIsNewSpeakerVoice())
  }

  const renderRemoveSpeakerVoicePopup = () => {
    return (
      <RemoveSpeakerVoicePopup
        closePopup={handleCloseVoiceStudioPopups}
      />
    )
  }

  const renderSidePanel = () => {
    return (
      <SpeakerVoiceSidePanel
        currentWorkspaceId={currentWorkspaceId}
        speakerVoice={openedSpeakerVoice}
        isNewSpeakerVoice={isNewSpeakerVoice}
        fullSpeakerVoiceSidePanel={fullSpeakerVoiceSidePanel}
        shouldRender={!!openedSpeakerVoice}
        resetCurrentSpeakerVoice={resetCurrentSpeakerVoice}
        resetIsNewCurrentSpeakerVoice={resetIsNewCurrentSpeakerVoice}
        setCurrentSpeakerVoice={setCurrentSpeakerVoice}
        setFullSpeakerVoiceSidePanel={setFullSpeakerVoiceSidePanel}
      />
    )
  }

  const renderVoiceStudio = () => {
    return (
      <div
        className="VoiceStudio"
        id="voiceStudio"
      >
        <Sidebar
          pageName="voiceStudio"
        />
        <SpeakerVoicesTable
          setCurrentSpeakerVoice={setCurrentSpeakerVoice}
        />
        {removeSpeakerVoicePopupIsOpen && renderRemoveSpeakerVoicePopup()}
        {renderSidePanel()}
      </div>
    )
  }

  return (
    <React.Fragment>
      <Forwarder />
      {renderVoiceStudio()}
    </React.Fragment>
  )
}

export default VoiceStudio
